import { Stack } from "@mantine/core";
import { TinyPodcasListItem } from "./TinyPodcasListItem";

export function PopularPodcasts({ podcasts }: { podcasts: Podcast[] | undefined }) {
    if (!podcasts) {
        return null;
    }
    return (
        <Stack gap="sm">
            {podcasts.map((podcast) => {
                return <TinyPodcasListItem key={`popular-podcast-${podcast.id}`} podcast={podcast} />;
            })}
        </Stack>
    );
}
